/**
 * 企画連絡承認画面Output用VOクラス
 *
 * @export KYMW1317OutputModel
 * @class KYMW1317OutputModel
 */
export class KYMW1317OutputModel {

  // 承認処理を実行したかのフラグ
  public isExecuteApproval = false;
}
